import { trackEvent } from 'api/index'
import { loadScript } from 'utils/loadScript'

import { demoVariant } from './experiment'

const CALENDLY_WIDGET_JS =
  'https://assets.calendly.com/assets/external/widget.js'
const CALENDLY_WIDGET_CSS =
  'https://assets.calendly.com/assets/external/widget.css'

let calendlyAssets
let calendlyTrackingBound = false

const bindCalendlyTracking = () => {
  if (calendlyTrackingBound) return
  calendlyTrackingBound = true

  window.addEventListener('message', event => {
    if (event.data?.event === 'calendly.event_scheduled') {
      trackEvent('Marketing:BookDemo:Meeting booked', {
        demo_variant: demoVariant()
      })
    }
  })
}

export const loadCalendlyAssets = () => {
  if (!calendlyAssets) {
    if (!document.querySelector(`link[href="${CALENDLY_WIDGET_CSS}"]`)) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = CALENDLY_WIDGET_CSS
      document.head.appendChild(link)
    }
    calendlyAssets = loadScript(CALENDLY_WIDGET_JS)
    bindCalendlyTracking()
  }

  return calendlyAssets
}

// Calendly stores only these five params on a booking; anything else on the
// widget URL is discarded. The page is reached through the l.rw.rw shortener,
// which appends `originpath` — we carry it as utm_content so the booking record
// knows which page the visitor came from.
const CALENDLY_TRACKING_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term'
]

const withAttribution = calendlyUrl => {
  try {
    const current = new URLSearchParams(window.location.search)
    const target = new URL(calendlyUrl)

    CALENDLY_TRACKING_PARAMS.forEach(param => {
      const value = current.get(param)
      if (value) target.searchParams.set(param, value)
    })

    const originPath = current.get('originpath')
    if (originPath && !target.searchParams.has('utm_content')) {
      target.searchParams.set('utm_content', originPath)
    }

    return target.toString()
  } catch {
    return calendlyUrl
  }
}

// Variant B's form doesn't ask for a name, so Calendly collects it there and
// only the email is prefilled.
export const openCalendly = (calendlyUrl, { name, email }) => {
  loadCalendlyAssets()
    .then(() => {
      window.Calendly.initPopupWidget({
        url: withAttribution(calendlyUrl),
        prefill: name ? { name, email } : { email }
      })
    })
    .catch(error => {
      trackEvent('Marketing:BookDemo:Calendly failed', {
        error_reason: error?.message || error?.type || 'unknown'
      })
    })
}
